import { render, staticRenderFns } from "./EdicaoFornecedor.vue?vue&type=template&id=db2a12c0&"
import script from "./EdicaoFornecedor.vue?vue&type=script&lang=js&"
export * from "./EdicaoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports